export const hamburgerOpenButtonMetadata = {
    canConnectToCode: () => false
}
